import React, { forwardRef, memo } from "react";

const Tab = forwardRef(({
    id,
    title,
    index,
    disabled,
    handleChange,
    ariaSelected,
    ariaControls,
    tabIndex
}, ref) => {
    return (
        <li role="presentation" data-testid="tab">
            <button
                data-testid="tab-button"
                role="tab"
                id={id}
                aria-selected={ariaSelected}
                {...ariaControls}
                tabIndex={tabIndex}
                onClick={() => handleChange(index)}
                ref={ref}
                disabled={disabled}
            >
                {title}
            </button>
        </li>
    );
});

export default memo(Tab);
